import React from 'react';
import styled from 'styled-components';

import EventItem from './EventItem';

export const EventsList: React.FunctionComponent<{ events: any[]}> = ({ events }) => {
  if (events.length === 0) { return <div /> }

  return (
    <EventsListContainer>
      {events.map((event) => <EventItem key={event.get('id')} item={event} />)}
    </EventsListContainer>
  );
}

const EventsListContainer = styled.div`
  padding: 10px 10px 0px 10px;
`;

export default EventsList;
